import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useLabelsColors = (config) => {
  return useQuery({
    ...config,
    queryKey: "labels-colors",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/labels/colors`,
        signal,
      }),
  });
};
